import { Box } from '@branch-messenger/willow-ui'
import { FC } from 'react'

import { Skeleton } from '@/components/skeleton/styles'

export const ConnectedCardLoading: FC = () => {
  return (
    <Box
      $display="flex"
      $direction="column"
      $gap={4}
      $align="initial"
      $fullWidth
    >
      {/* Title skeleton */}
      <Skeleton $height={24} $width={120} />
      <Box $display="flex" $justify="space-between" $fullWidth>
        <Box $display="flex" $gap={4} $fullWidth>
          {/* Card network icon skeleton */}
          <Skeleton $height={32} $width={32} />

          <Box $display="flex" $direction="column" $align="initial" $gap={1}>
            {/* Card number skeleton */}
            <Skeleton $height={16} $width={120} />
            {/* Expiration date skeleton */}
            <Skeleton $height={14} $width={120} />
          </Box>
        </Box>
        {/* Manage button skeleton */}
        <Skeleton $height={32} $width={80} />
      </Box>
    </Box>
  )
}
